import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { enTokenCMD } from "../../../lib/classTalk/CodeEnum";
import { setElementForClassMonitor } from "../../../lib/MediaSoupClient";
import { xmitCmd_MessageForSmartTV } from "../../../lib/RabbitmqClient";
import { initFuncProcArr } from "../../../lib/rbmq/rcvMsgFromRbmq";

// 260728 ClassMonitor 전용 학생 영상 타일로 기존 SmartTV DOM 이동 로직과 분리한다.
const ClassMonitorVideoTile = ({ index, user, liveSeq, mode, isReady, onSelect, className = "" }) => {
    const { t } = useTranslation("live");
    const videoRef = useRef(null);
    const audioRef = useRef(null);
    const [status, setStatus] = useState("WAITING");

    useEffect(() => {
        const processStatus = value => {
            if (value === "connect" || value === "connect-client" || value === "shared-screen-mode") setStatus("LIVE");
            if (value === "disconnect" || value === "shared-stop-mode") setStatus("DISCONNECTED");
        };
        initFuncProcArr(index, user.userSeq, processStatus);
        return () => initFuncProcArr(index, -1, null);
    }, [index, user.userSeq]);

    useEffect(() => {
        if (isReady && videoRef.current) {
            setElementForClassMonitor(index, user.userSeq, videoRef.current, audioRef.current);
        }
    }, [index, isReady, user.userSeq]);

    useEffect(() => {
        if (!isReady) return;
        const tvMode = mode !== 0;
        xmitCmd_MessageForSmartTV("smart_tv", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, user.userSeq, user.userNickname, liveSeq, tvMode, mode);
        xmitCmd_MessageForSmartTV("android", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, user.userSeq, user.userNickname, liveSeq, tvMode, mode);
        return () => {
            // 260728 그룹·확대 화면에서 빠진 학생은 이 모니터의 고화질 요청 키를 즉시 해제한다.
            if (tvMode) {
                xmitCmd_MessageForSmartTV("smart_tv", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, user.userSeq, user.userNickname, liveSeq, false, 0);
                xmitCmd_MessageForSmartTV("android", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, user.userSeq, user.userNickname, liveSeq, false, 0);
            }
        };
    }, [isReady, liveSeq, mode, user.userNickname, user.userSeq]);

    return (
        <button type="button" data-monitor-index={index} className={`class-monitor-tile ${className}`} onClick={onSelect} aria-label={t("클래스_모니터_화면_크게_보기", { name: user.userNickname })}>
            {/* 260728 RabbitMQ 상태와 별개로 실제 MediaSoup 영상 재생 상태를 화면에 반영한다. */}
            <video
                ref={videoRef}
                poster="/images/connect.png"
                playsInline
                autoPlay
                muted
                onLoadedData={() => setStatus("LIVE")}
                onPlaying={() => setStatus("LIVE")}
                onEmptied={() => setStatus("WAITING")}
                onEnded={() => setStatus("DISCONNECTED")}
                onError={() => setStatus("DISCONNECTED")}
            />
            <audio ref={audioRef} autoPlay style={{ display: "none" }} />
            <span className="class-monitor-tile-name">{user.userNickname}</span>
            <span className="class-monitor-tile-status">{t(`클래스_모니터_상태_${status}`)}</span>
        </button>
    );
};

export default ClassMonitorVideoTile;
